import { ListItem, Typography } from '@mui/material';
import { themeObject } from 'lib';

export const radioOptions: string[] = ['2D', '3D'];

export const lgOverlayStyles = {
    overlayContainer: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    graphContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        pointerEvents: 'none',
        p: 2,
    },
    graphBtn: {
        pointerEvents: 'auto',
        height: '44px',
        width: '150px',
        borderRadius: '20px',
        backgroundColor: '#F7F9FAA6',
        textTransform: 'none',
    },
    cogIcon: {
        color: themeObject.palette.grayScale[500],
        fontSize: '16px',
        margin: '2px',
    },
    btnTitle: {
        fontFamily: 'Red Hat Text',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: '15px',
        color: themeObject.palette.primary[700],
    },
    menu: {
        '.MuiMenu-paper': {
            p: 2,
            borderRadius: '20px',
        },
    },
    formControl: {
        mb: 1,
    },
    menuTitleContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    menuTitleIcon: {
        color: themeObject.palette.grayScale[500],
        fontSize: '18px',
        marginRight: '4px',
    },
    menuTitle: {
        fontFamily: 'Red Hat Text',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '21px',
        color: themeObject.palette.primary[700],
    },
    listItem: {
        py: 0.5,
        display: 'flex',
        alignItems: 'center',
    },
    listTextBold: {
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '500',
        fontFamily: 'Red Hat Text',
        minWidth: '50px',
        marginRight: '2',
    },
    listText: {
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '400',
        fontFamily: 'Red Hat Text',
    },
    expandBtnContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        pointerEvents: 'none',
        pl: 4,
    },
    expandBtn: {
        pointerEvents: 'auto',
        p: 3,
        boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.12)',
        borderRadius: '50px 50px 0 0',
    },
};

export const generateListItem = (
    label: string,
    description: string
): React.JSX.Element => (
    <ListItem key={label} sx={lgOverlayStyles.listItem}>
        <Typography sx={lgOverlayStyles.listTextBold}>{label}</Typography>
        <Typography sx={lgOverlayStyles.listText}>
            {description.includes('<br/>') ? (
                <>
                    {description.split('<br/>')[0]}
                    <br />
                    {description.split('<br/>')[1]}
                </>
            ) : (
                description
            )}
        </Typography>
    </ListItem>
);
